import { TeContainerSlim } from '@topcon/tuicl-react';
import styled from 'styled-components';

import { background } from '../../../providers/theme/theme.index';

const TeContainerSlimWrapper = styled(TeContainerSlim)`
  width: 100%;
  background-color: ${background.primary} !important;
`;

export default TeContainerSlimWrapper;
